if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            // --- Linked Products Logic ---
            console.log('LINKED PRODUCTS: Starting logic...'); // Always log this
            try {
              const mainProductId = formData.get('id');
              const sellingPlanId = formData.get('selling_plan');
              const settings = window.linkedProductsSettings || {};
              const enableLogging = true; // Force enable for debugging
              
              console.log('LINKED PRODUCTS: Window object check:', {
                windowExists: !!window.linkedProductsSettings,
                windowSettingsKeys: window.linkedProductsSettings ? Object.keys(window.linkedProductsSettings) : 'N/A'
              });
              
              console.log('LINKED PRODUCTS: Basic info', {
                mainProductId,
                sellingPlanId,
                settingsExists: !!settings,
                windowObject: window.linkedProductsSettings
              });
              
              console.log('Linked Products Debug:', {
                mainProductId,
                sellingPlanId,
                settings,
                settingsKeys: Object.keys(settings),
                rawAdvancedMap: settings.advancedMap,
                rawSimpleMap: settings.map,
                windowSettings: window.linkedProductsSettings
              });

              let linkedProducts = [];

              // Try advanced mapping first (variant + selling plan)
              if (settings.advancedMap) {
                let advancedMap = {};
                try {
                  console.log('LINKED PRODUCTS: Raw advancedMap type:', typeof settings.advancedMap, settings.advancedMap);
                  
                  if (typeof settings.advancedMap === 'string' && settings.advancedMap.trim()) {
                    advancedMap = JSON.parse(settings.advancedMap);
                  } else if (typeof settings.advancedMap === 'object' && settings.advancedMap !== null) {
                    advancedMap = settings.advancedMap;
                  }
                  
                  console.log('LINKED PRODUCTS: Parsed advanced mapping:', advancedMap);
                  console.log('LINKED PRODUCTS: Advanced mapping keys:', Object.keys(advancedMap));
                } catch (e) {
                  console.error('LINKED PRODUCTS: Failed to parse advanced mapping:', e, 'Raw value:', settings.advancedMap);
                }

                // Create mapping keys to check
                const mappingKeys = [];
                if (sellingPlanId) {
                  mappingKeys.push(`${mainProductId}|${sellingPlanId}`); // Exact match
                  mappingKeys.push(`${mainProductId}|any`); // Any selling plan
                }
                mappingKeys.push(mainProductId); // Variant only (for fallback)

                console.log('LINKED PRODUCTS: Checking mapping keys:', mappingKeys);
                console.log('LINKED PRODUCTS: Available keys in advancedMap:', Object.keys(advancedMap));
                
                // Debug each key check
                mappingKeys.forEach(key => {
                  console.log(`LINKED PRODUCTS: Checking key "${key}":`, advancedMap[key]);
                });

                // Check each mapping key in order of preference
                for (const key of mappingKeys) {
                  if (advancedMap[key]) {
                    linkedProducts = Array.isArray(advancedMap[key]) ? advancedMap[key] : [advancedMap[key]];
                    if (enableLogging) {
                      console.log(`Found advanced mapping for key: ${key}`, linkedProducts);
                    }
                    break;
                  }
                }
              }

              // Fallback to simple variant mapping if no advanced match found
              if (linkedProducts.length === 0 && settings.fallbackBehavior === 'variant_only') {
                const simpleMap = settings.map || {};
                if (simpleMap[mainProductId]) {
                  linkedProducts = Array.isArray(simpleMap[mainProductId]) ? simpleMap[mainProductId] : [simpleMap[mainProductId]];
                  if (enableLogging) {
                    console.log('Using fallback variant mapping:', linkedProducts);
                  }
                }
              }

              // Add linked products to cart (always as one-time purchases when main product has subscription)
              if (linkedProducts.length > 0) {
                console.log('LINKED PRODUCTS: Adding products to cart:', linkedProducts);
                linkedProducts.forEach(async (linkedId) => {
                  const linkedBody = { id: linkedId, quantity: 1 };
                  // Always add linked products as one-time purchases (no selling_plan)
                  
                  console.log('LINKED PRODUCTS: Sending request for:', linkedBody);
                  
                  try {
                    const response = await fetch(`${routes.cart_add_url}`, {
                      method: 'POST',
                      headers: { 
                        'X-Requested-With': 'XMLHttpRequest',
                        'Content-Type': 'application/json'
                      },
                      body: JSON.stringify(linkedBody)
                    });
                    
                    console.log(`LINKED PRODUCTS: Raw response for ${linkedId}:`, response.status, response.statusText);
                    
                    // Check if response is JSON or HTML
                    const contentType = response.headers.get('content-type');
                    console.log(`LINKED PRODUCTS: Content-Type:`, contentType);
                    
                    let result;
                    if (contentType && contentType.includes('application/json')) {
                      result = await response.json();
                    } else {
                      const text = await response.text();
                      console.log(`LINKED PRODUCTS: HTML response for ${linkedId}:`, text.substring(0, 500));
                      result = { error: 'Non-JSON response received', html: text.substring(0, 200) };
                    }
                    
                    console.log(`LINKED PRODUCTS: Parsed result for ${linkedId}:`, result);
                    
                    if (!response.ok) {
                      console.error(`LINKED PRODUCTS: Failed to add ${linkedId} (${response.status}):`, result);
                    } else {
                      console.log(`LINKED PRODUCTS: Successfully added ${linkedId}`);
                    }
                  } catch (error) {
                    console.error(`LINKED PRODUCTS: Error adding ${linkedId}:`, error);
                  }
                });
              } else {
                console.log('LINKED PRODUCTS: No linked products found for variant:', mainProductId);
              }
            } catch (err) {
              console.error('Linked products logic error:', err);
            }
            // --- End Linked Products Logic ---

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
